import { ModalPresetsStruct } from "@/struct/ui/UIModalStruct";

export type TypesModals = keyof typeof MODAL_PRESETS;

export const MODAL_PRESETS: Record<string, ModalPresetsStruct> = {
  no_funds: {
    title: "Недостаточно средств для подключения",
    mainBtnTitle: "Ок",
    status: "error",
  },
  general_error: {
    title: "Ошибка <br>Что-то пошло не&nbsp;так",
    mainBtnTitle: "закрыть",
    status: "error",
  },
  base_error: {
    title: "Произошла ошибка",
    mainBtnTitle: "Закрыть окно",
    //status: "error",
  },
  premium_change_success: {
    title: "Ваш номер успешно изменен",
    mainBtnTitle: "Окей",
    status: "success",
  },
  premium_change_error_6months: {
    title: "С предыдущей смены номера не прошло 6 месяцев",
    mainBtnTitle: "Продолжить",
  },
  premium_change_error_taken: {
    title:
      "Этот номер уже занят. Пожалуйста, выберите другой, чтобы продолжить",
    mainBtnTitle: "Продолжить",
  },
};
